module.exports = __webpack_public_path__ + "static/media/ema.ac325d87.png";